import { RouterEvent } from '@angular/router';
import { LogLevel } from '@shared/enums/LogLevel';

export abstract class LoggingService {
  abstract logPageViewWithEvent(event: RouterEvent);
  abstract logEvent(name: string, properties?: any, measurements?: any);
  abstract logError(error: Error, properties?: any, measurements?: any);
  abstract log(message: string, properties?: any, logLevel?: LogLevel);
  abstract setAuthenticatedUserContext(
    userId: string,
    userType?: string,
    storeInCookie?: boolean
  );
  abstract clearAuthenticatedUserContext();
}
